import React, { useEffect,useState } from 'react';
import styled from "styled-components";
import Anime from 'animejs';
import logo  from "../logo.png";

const SplashScreen = () => {
  const [showSplash, setShowSplash] = useState(true);
  useEffect(() => {
    const textWrapper = document.querySelector('.text-wrapper');
    textWrapper.innerHTML = textWrapper.textContent.replace(
      /\S/g,
      "<span class='letter'>$&</span>"
    );

    Anime.timeline({ loop: false })
      .add({
        targets: '.text-wrapper .letter',
        opacity: [0, 1],
        easing: 'easeInOutQuad',
        duration: 2250,
        delay: (el, i) => 150 * (i + 1),
      })
      .add({
        targets: '.text-wrapper',
        opacity: 0,
        duration: 1000,
        easing: 'easeOutExpo',
        delay: 2000,
        complete:()=>{setShowSplash(false)}
      });
  }, []);

  return (
    <StyledSplashscreen className={showSplash ? "splash-screen show" : "splash-screen"}>
      <img src={logo} alt="logo" />
       <div className="text-wrapper">
        <div className="animated-text">B-LOVEDTH</div>
      </div>
    </StyledSplashscreen>
  );
};

export default SplashScreen;

const StyledSplashscreen = styled.div`
  position: fixed;
  z-index: 9999;
  background: var(--bg-color);
  top:0;
  height:100vh;
  left:0;
  opacity:0;
  width: 100%;
  scale:0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  justify-content: center;
  transition: all 1s ease-in-out;
  border-bottom-left-radius:20px ;
  border-bottom-right-radius:20px ;
  &.show{
    scale: 1;
    opacity:1;
  }
  img{
    position:absolute;
    z-index:-1;
    opacity:0.3;
    width: clamp(10em,20vw,500px);
    filter:drop-shadow( 5px 5px 10px var(--accent-text));
    animation: rotate 20s linear infinite;
    @keyframes rotate {
      from{transform:rotate(0deg)}
      to{transform:rotate(360deg)}
    }
  }
  .text-wrapper{
    color:var(--accent-text);
    letter-spacing:5px;
    font-family:"Quantico";
    font-size:6vw;
    font-weight: 700;
    filter:drop-shadow( 5px 5px 10px var(--accent-text));
  }
  @media  (max-width: 768px) {
    .text-wrapper{
      font-size:12vw;
    }
  }
  
`;
